import { Box, Card, Container, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';

import './Banner.scss';

const Banner = () => {
  const { t } = useTranslation();
  return (
    <div className="background-banner">
      <img src={require('../../assets/images/bg.png')} />
    </div>
  );
};

export default Banner;
